import * as React from 'react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { IconButtonProps } from './types';

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ tooltip, tooltipSide = 'top', children, ...props }, ref) => {
    return (
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              ref={ref}
              aria-label={typeof tooltip === 'string' ? tooltip : undefined}
              {...props}
            />
          }
        >
          {children}
        </TooltipTrigger>
        <TooltipContent side={tooltipSide}>{tooltip}</TooltipContent>
      </Tooltip>
    );
  },
);
IconButton.displayName = 'IconButton';
